// extracted by mini-css-extract-plugin
export var bigOrangeHeaders = "basicPage-module--bigOrangeHeaders--6f6e7";
export var contentWrapper = "basicPage-module--contentWrapper--6c88d";
export var textContent = "basicPage-module--textContent--3c6dd";
export var wrapper = "basicPage-module--wrapper--c18c8";